// Event Tracking API

import instance from '../axios';
import * as endpoints from './endpoints';

export const eventTrackingApiHandler = (payload) => {
  const url = endpoints.EVENT_TRACKING;
  return instance.post(url, payload);
};
